<div class="cmn-dialog-card-view">
    <button *ngIf="content?.isCloseIconVisible" class="dialog-close-btn" (click)="closeDialog()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>

    <div class="dialog-header" *ngIf="content?.title">
        <span class="icon dialog-header-icon" *ngIf="content?.image" [svgIcon]="content?.image"></span>
        <h1 class="dialog-header-title-gradient">{{ content.title }}</h1>
    </div>

    <mat-dialog-actions *ngIf="content?.isButtonShow != false">
        <div class="dialog-actions">
            <div class="dialog-actions-btn">
                <button type="button" class="primary-fill-btn btn-w100" (click)="onConfirmClick()">
                    {{ content?.buttonName || "Confirm" }}
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</div>
